import { HttpViewState } from '../../analyticsUiTypes';

export const initialHttpViewState: HttpViewState = {
  activePage: 1,
  pageSize: 5,
  searchKeyword: '',
  selectedHttpRequest: null,
  selectedViewTab: 'defaultTab',
};
